import { create } from 'zustand';

interface GlobalQueryStore {
  isQueryingAllowed: boolean;
  isAuthTransitionInProgress: boolean;
  setQueryingAllowed: (allowed: boolean) => void;
  setAuthTransitionInProgress: (inProgress: boolean) => void;
  startAuthTransition: () => void;
  endAuthTransition: () => void;
}

/**
 * Global store to control ALL React Query execution during auth transitions
 * This prevents React Error #300 by disabling queries during critical state changes
 */
export const useGlobalQueryStore = create<GlobalQueryStore>((set) => ({
  isQueryingAllowed: false,
  isAuthTransitionInProgress: false,
  
  setQueryingAllowed: (allowed: boolean) => {
    console.log('[GlobalQueryStore] Setting querying allowed:', allowed);
    set({ isQueryingAllowed: allowed });
  },
  
  setAuthTransitionInProgress: (inProgress: boolean) => {
    console.log('[GlobalQueryStore] Auth transition in progress:', inProgress);
    set({ isAuthTransitionInProgress: inProgress });
    if (inProgress) {
      set({ isQueryingAllowed: false });
    }
  },
  
  startAuthTransition: () => {
    console.log('[GlobalQueryStore] Starting auth transition - disabling all queries');
    set({ 
      isAuthTransitionInProgress: true,
      isQueryingAllowed: false 
    });
  },
    endAuthTransition: () => {
    console.log('[GlobalQueryStore] Ending auth transition - enabling queries');
    set({ 
      isAuthTransitionInProgress: false,
      isQueryingAllowed: true 
    });
  },
}));
